import { all, call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  fetchReconciliationFiltersSuccess,
  fetchReconciliationFiltersFailure,
} from '../actions';
import {
  getMappingCodesFilter,
  getAccountsFilter,
  MappingCodesFilterResponse,
  AccountsFilterResponse,
} from '../api';
import { FetchReconciliationFiltersRequestAction } from '../types';

export function* fetchReconciliationFiltersSaga(
  action: FetchReconciliationFiltersRequestAction
) {
  try {
    const { connectionId, mappingId } = action.payload;

    const [mappingCodesRes, accountsRes]: [
      MappingCodesFilterResponse,
      AccountsFilterResponse,
    ] = yield all([
      call(getMappingCodesFilter, mappingId),
      call(getAccountsFilter, connectionId),
    ]);
    const mappingCodesErr: ApiError | null = checkResponse(
      mappingCodesRes?.responseMessage
    );
    if (mappingCodesErr) throw mappingCodesErr;
    const accountsErr: ApiError | null = checkResponse(
      accountsRes?.responseMessage
    );
    if (accountsErr) throw accountsErr;
    yield put(
      fetchReconciliationFiltersSuccess(
        mappingCodesRes.data.mappingCodes,
        accountsRes.data.accounts,
        undefined
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchReconciliationFiltersFailure());
  }
}
